import React from "react";
import { PageHeader, Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Newspaper, ArrowSquareOut } from "@phosphor-icons/react";

export default function FreightNews() {
  return (
    <div>
      <PageHeader title="Freight News" subtitle="Live industry news & market updates from FreightWaves"
        actions={<a href="https://www.freightwaves.com" target="_blank" rel="noreferrer"><Button className="bg-blue-600 text-white hover:bg-blue-700 font-semibold" data-testid="freightnews-open"><ArrowSquareOut size={16} className="mr-1.5" />Open FreightWaves</Button></a>} />
      <Panel className="p-0 overflow-hidden" data-testid="freightnews-panel">
        <div className="bg-blue-50 border-b border-blue-100 px-5 py-2.5 flex items-center gap-2 text-sm text-blue-700">
          <Newspaper size={16} weight="duotone" />
          If the live feed doesn't load below, use “Open FreightWaves” to view in a new tab.
        </div>
        <iframe
          title="FreightWaves"
          src="https://www.freightwaves.com/news"
          className="w-full h-[72vh] border-0 block bg-white"
          loading="lazy"
          referrerPolicy="no-referrer"
        />
      </Panel>
    </div>
  );
}
